import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppPopoversService } from './app-popovers.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidator } from '../validators/custom.validator';
import { ModalDirective } from 'ngx-bootstrap';
import { environment } from '@app/env';
import { GetLegalTexts$Response, Lang, LangValues } from '@api/types';
import { ApiService } from '@api/service';
import { AlertService } from '../../api/alert.service';
import { RecipesService } from '../../recipes/recipes.service';

@Component({
  selector: 'app-popovers',
  templateUrl: './app-popovers.component.html',
  styleUrls: ['./app-popovers.component.scss']
})
export class AppPopoversComponent implements OnInit, OnDestroy {
  @ViewChild('cookieModal', { static: false })
  cookieModal: ModalDirective;
  @ViewChild('tosModal', { static: false })
  tosModal: ModalDirective;
  @ViewChild('privacyModal', { static: false })
  privacyModal: ModalDirective;
  @ViewChild('weightChangeModal', { static: false })
  weightChangeModal: ModalDirective;
  @ViewChild('confirmUpdateProfileModalContent', { static: false })
  confirmUpdateProfileModalContent: ModalDirective;
  @ViewChild('confirmGiftModalContent', { static: false })
  confirmGiftModalContent: ModalDirective;
  @ViewChild('targetWeightChangeModal', { static: false })
  targetWeightChangeModal: ModalDirective;
  @ViewChild('confirmAddMemberModalContent', { static: false })
  confirmAddMemberModalContent: ModalDirective;
  @ViewChild('cancelSubscriptionModalContent', { static: false })
  cancelSubscriptionModalContent: ModalDirective;
  @ViewChild('emailLoginModal', { static: false })
  emailLoginModal: ModalDirective;
  @ViewChild('emailLoginErrorModal', { static: false })
  emailLoginErrorModal: ModalDirective;
  @ViewChild('emailLoginConfirmationModal', { static: false })
  emailLoginConfirmationModal: ModalDirective;
  @ViewChild('subscriptionNeededModal', { static: false })
  subscriptionNeededModal: ModalDirective;
  @ViewChild('shareMeal', { static: false })
  shareMeal: ModalDirective;
  @ViewChild('shareMenu', { static: false })
  shareMenu: ModalDirective;
  @ViewChild('banklinkPolling', { static: false })
  banklinkPolling: ModalDirective;

  @ViewChild('shareEmailModalSuccess', { static: false })
  shareEmailModalSuccess: any;
  @ViewChild('generalErrorMessage', { static: false })
  generalErrorMessage: any;
  @ViewChild('otherItemInput', { static: false })
  otherItemInput: any;

  @ViewChild('newList', { static: false })
  newList: ModalDirective;
  @ViewChild('addItem', { static: false })
  addItem: ModalDirective;
  @ViewChild('removeItem', { static: false })
  removeItem: ModalDirective;
  @ViewChild('shareList', { static: false })
  shareList: ModalDirective;
  @ViewChild('createCart', { static: false })
  createCart: ModalDirective;
  @ViewChild('resendCart', { static: false })
  resendCart: ModalDirective;

  public env = environment;
  public form: FormGroup;
  public shoppinglistSendForm: FormGroup;
  public shareMealForm: FormGroup;
  public shareMenuForm: FormGroup;
  public magicLinkForm: FormGroup;
  public addItemForm: FormGroup;
  public shareForm: FormGroup;
  public addOtherItemForm: FormGroup;
  public savedEmail: string;
  public options: any;
  public shopCartDisabled: boolean;
  private formChanged: boolean;
  private callback1: Function;
  private callback2: Function;
  public legalTexts: GetLegalTexts$Response;
  public showStatic: boolean;
  public isLoading: boolean;
  public shoppingListSending: boolean;
  public recipesSending: boolean;
  public shareProcessing: boolean;
  public otherItemLoading: boolean;
  public pdfToken: string;
  public shopCartInfoDisabled: boolean;

  private getLegalTexts$: Subscription;

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private appPopoversService: AppPopoversService,
    private fb: FormBuilder,
    private alertService: AlertService,
    private recipesService: RecipesService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      email: [null, Validators.compose([Validators.required, CustomValidator.mailFormat()])],
      password: [null, Validators.required]
    });

    this.magicLinkForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, CustomValidator.mailFormat()])]
    });

    this.shoppinglistSendForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, CustomValidator.mailFormat()])]
    });

    this.shareMealForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, CustomValidator.mailFormat()])]
    });

    this.shareMenuForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, CustomValidator.mailFormat()])]
    });

    this.addOtherItemForm = this.fb.group({
      name: ['', Validators.compose([Validators.required, Validators.minLength(2)])]
    });

    this.addItemForm = this.fb.group({
      name: ['', Validators.compose([Validators.required, Validators.minLength(2)])]
    });
    this.shareForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, CustomValidator.mailFormat()])]
    });

    // keep the two email inputs in sync
    this.form.get('email').valueChanges.subscribe(res => {
      this.magicLinkForm.get('email').patchValue(res, { emitEvent: false });
    });

    // keep the two email inputs in sync
    this.magicLinkForm.get('email').valueChanges.subscribe(res => {
      this.form.get('email').patchValue(res, { emitEvent: false });
    });

    this.route.queryParams.subscribe((params: any) => {
      if (params['popover']) {
        this.open(params['popover']);
      }
    });

    this.appPopoversService.openStream().subscribe(data => {
      this.open(data.id);
      this.callback1 = data.callback1;
      this.callback2 = data.callback2;
      this.options = data.options;
    });

    this.appPopoversService.closeStream().subscribe(id => {
      this.close(id);
    });
  }

  public runCallback1(value?, value2?): void {
    if (this.callback1) {
      this.callback1(value, value2);
    }
  }

  public runCallback2(value?, value2?): void {
    if (this.callback2) {
      this.callback2(value, value2);
    }
  }

  public onShow(): void {
    this.appPopoversService.onShow();
  }

  public onHide(): void {
    this.appPopoversService.onHide();
  }

  private open(id: string) {
    switch (id) {
      case 'cookie':
        if (!this.legalTexts) {
          this.getLegalTexts();
        }
        this.cookieModal.show();
        break;
      case 'privacy':
        if (!this.legalTexts) {
          this.getLegalTexts();
        }
        this.privacyModal.show();
        break;
      case 'terms':
        if (!this.legalTexts) {
          this.getLegalTexts();
        }
        this.tosModal.show();
        break;
      case 'weightChangeModal':
        this.weightChangeModal.show();
        break;
      case 'confirmUpdateProfileModalContent':
        this.confirmUpdateProfileModalContent.show();
        break;
      case 'confirmGiftModalContent':
        this.confirmGiftModalContent.show();
        break;
      case 'targetWeightChangeModal':
        this.targetWeightChangeModal.show();
        break;
      case 'confirmAddMemberModalContent':
        this.confirmAddMemberModalContent.show();
        break;
      case 'cancelSubscriptionModalContent':
        this.cancelSubscriptionModalContent.show();
        break;
      case 'emailLoginModal':
        this.form.controls['email'].patchValue('');
        this.form.controls['password'].patchValue('');
        this.form.markAsPristine();
        this.magicLinkForm.controls['email'].patchValue('');
        this.magicLinkForm.markAsPristine();
        this.emailLoginModal.show();
        break;
      case 'emailLoginErrorModal':
        this.emailLoginErrorModal.show();
        break;
      case 'emailLoginConfirmationModal':
        this.emailLoginConfirmationModal.show();
        break;
      case 'subscriptionNeededModal':
        this.subscriptionNeededModal.show();
        break;
      case 'shareMeal':
        this.getPdfToken();
        this.shareMealForm.reset();
        this.shareMeal.show();
        break;
      case 'shareMenu':
        this.getPdfToken();
        this.shareMenuForm.reset();
        this.shareMenu.show();
        break;
      case 'banklinkPolling':
        this.banklinkPolling.show();
        break;
      case 'newList':
        this.newList.show();
        break;
      case 'addItem':
        this.isLoading = false;
        this.addItemForm.reset();
        this.addItem.show();
        break;
      case 'removeItem':
        this.isLoading = false;
        this.removeItem.show();
        break;
      case 'shareList':
        this.isLoading = false;
        this.shareForm.reset();
        this.shareList.show();
        break;
      case 'createCart':
        this.createCart.show();
        break;
      case 'resendCart':
        this.resendCart.show();
        break;
      default:
        return;
    }
  }

  private close(id: string) {
    switch (id) {
      case 'cookie':
        this.cookieModal.hide();
        break;
      case 'privacy':
        this.privacyModal.hide();
        break;
      case 'terms':
        this.tosModal.hide();
        break;
      case 'weightChangeModal':
        this.weightChangeModal.hide();
        break;
      case 'confirmUpdateProfileModalContent':
        this.confirmUpdateProfileModalContent.hide();
        break;
      case 'confirmGiftModalContent':
        this.confirmGiftModalContent.hide();
        break;
      case 'targetWeightChangeModal':
        this.targetWeightChangeModal.hide();
        break;
      case 'confirmAddMemberModalContent':
        this.confirmAddMemberModalContent.hide();
        break;
      case 'cancelSubscriptionModalContent':
        this.cancelSubscriptionModalContent.hide();
        break;
      case 'emailLoginModal':
        this.emailLoginModal.hide();
        break;
      case 'emailLoginErrorModal':
        this.emailLoginErrorModal.hide();
        break;
      case 'emailLoginConfirmationModal':
        this.emailLoginConfirmationModal.hide();
        break;
      case 'subscriptionNeededModal':
        this.subscriptionNeededModal.hide();
        break;
      case 'shareMeal':
        this.shareMeal.hide();
        break;
      case 'shareMenu':
        this.shareMeal.hide();
        break;
      case 'banklinkPolling':
        this.banklinkPolling.hide();
        break;
      case 'newList':
        this.newList.hide();
        break;
      case 'addItem':
        this.isLoading = false;
        this.addItem.hide();
        break;
      case 'removeItem':
        this.isLoading = false;
        this.removeItem.hide();
        break;
      case 'shareList':
        this.shareList.hide();
        break;
      case 'createCart':
        this.createCart.hide();
        break;
      case 'resendCart':
        this.resendCart.hide();
        break;
      case 'all':
        if (this.cookieModal) {
          this.cookieModal.hide();
        }
        if (this.privacyModal) {
          this.privacyModal.hide();
        }
        if (this.tosModal) {
          this.tosModal.hide();
        }
        if (this.weightChangeModal) {
          this.weightChangeModal.hide();
        }
        if (this.confirmUpdateProfileModalContent) {
          this.confirmUpdateProfileModalContent.hide();
        }
        if (this.confirmGiftModalContent) {
          this.confirmGiftModalContent.hide();
        }
        if (this.targetWeightChangeModal) {
          this.targetWeightChangeModal.hide();
        }
        if (this.confirmAddMemberModalContent) {
          this.confirmAddMemberModalContent.hide();
        }
        if (this.cancelSubscriptionModalContent) {
          this.cancelSubscriptionModalContent.hide();
        }
        if (this.emailLoginModal) {
          this.emailLoginModal.hide();
        }
        if (this.emailLoginErrorModal) {
          this.emailLoginErrorModal.hide();
        }
        if (this.emailLoginConfirmationModal) {
          this.emailLoginConfirmationModal.hide();
        }
        if (this.subscriptionNeededModal) {
          this.subscriptionNeededModal.hide();
        }
        if (this.shareMeal) {
          this.shareMeal.hide();
        }
        if (this.shareMenu) {
          this.shareMenu.hide();
        }
        if (this.banklinkPolling) {
          this.banklinkPolling.hide();
        }
        if (this.newList) {
          this.newList.hide();
        }
        if (this.addItem) {
          this.addItem.hide();
        }
        if (this.removeItem) {
          this.removeItem.hide();
        }
        if (this.shareList) {
          this.shareList.hide();
        }
        if (this.resendCart) {
          this.resendCart.hide();
        }
        break;
      default:
        return;
    }
  }

  public goToSubscription() {
    this.subscriptionNeededModal.hide();
    this.router.navigate(['/profile/subscription']);
  }

  public getLegalTexts() {
    this.isLoading = true;
    this.getLegalTexts$ = this.api.legalTexts
      .getLegalTexts({
        lang: environment.lang.split('_')[0].toUpperCase() as Lang
      })
      .subscribe(
        res => {
          this.legalTexts = res;
          this.isLoading = false;
        },
        err => (this.isLoading = false)
      );
  }

  /* */
  handleShareMealPdf() {
    window.open(
      `${this.env.ABSOLUTE_PATH}/api/pdf/meal?id=${this.options.mealIds[0]}&token=${this.pdfToken}&lang=${environment.lang.split('_')[0]}`
    );
  }
  handleShareMenuPdf() {
    if (!this.options || !this.options.dates) {
      return;
    }
    const dates = this.options.dates
      .filter(option => option.selected)
      .map(option => option.date)
      .join(',');
    window.open(
      `${this.env.ABSOLUTE_PATH}/api/pdf/menu?dates=${dates}&token=${this.pdfToken}&lang=${environment.lang.split('_')[0]}`,
      '_blank'
    );
  }
  handleShareMealEmail() {
    this.shareProcessing = true;
    this.recipesService.shareMeals(this.shareMealForm.get('email').value, this.options.mealIds).subscribe(
      res => {
        this.handleShareEmailSuccess();
        this.shareMeal.hide();
      },
      err => this.handleShareEmailError()
    );
  }
  handleShareMenuEmail() {
    this.shareProcessing = true;
    const dates = this.options.dates.filter(option => option.selected).map(option => option.date);
    this.recipesService.shareMenu(this.shareMenuForm.get('email').value, dates).subscribe(
      res => {
        this.handleShareEmailSuccess();
        this.shareMenu.hide();
      },
      err => this.handleShareEmailError()
    );
  }
  handleShareEmailSuccess() {
    this.shareProcessing = false;
    this.alertService.addAlert(
      this.alertService.createCustomAlertObj(this.shareEmailModalSuccess.nativeElement.textContent, 'success', 3000)
    );
  }
  handleShareEmailError() {
    this.shareProcessing = false;
    this.alertService.addAlert(this.alertService.createCustomAlertObj(this.generalErrorMessage.nativeElement.textContent, 'danger', 3000));
  }
  getPdfToken(): void {
    this.api.pdfgen.getPdfGenerationToken().subscribe(res => (this.pdfToken = res.token));
  }

  isIOSApp(): boolean {
    return this.isIOS() && this.env.isCordova;
  }

  isIOS(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window['MSStream'];
  }

  public createCartContinue(): void {
    this.createCart.hide();
    this.runCallback1();
  }

  public resendCartContinue(): void {
    this.resendCart.hide();
    this.runCallback1();
  }

  public resendCartReset(): void {
    this.resendCart.hide();
    this.runCallback2();
  }

  public addItemFormSubmit(): void {
    this.isLoading = true;
    this.runCallback1(this.addItemForm.get('name').value);
  }

  public shareFormSubmit(): void {
    this.isLoading = true;
    this.runCallback1(this.shareForm.get('email').value);
  }

  public confirmGiftModalContentCancel(): void {
    this.confirmGiftModalContent.hide();
    this.runCallback2();
  }

  public toggleShopCardDisabled() {
    this.shopCartDisabled = !this.shopCartDisabled;
    if (this.shopCartDisabled) {
      localStorage.setItem('shopCartDisabled', 'true');
    } else {
      localStorage.removeItem('shopCartDisabled');
    }
  }

  ngOnDestroy() {
    if (this.getLegalTexts$) {
      this.getLegalTexts$.unsubscribe();
    }
  }
}
